import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Logo } from "@/components/site/ui";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useSeo } from "@/lib/seo";

const dest = (role) => (role === "bde" ? "/bde" : role === "customer" ? "/account" : "/admin");

export default function Login() {
    const nav = useNavigate();
    const { login } = useAuth();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [err, setErr] = useState("");
    const [loading, setLoading] = useState(false);
    useSeo({ title: "Login | SUDIGI" });

    const submit = async (e) => {
        e.preventDefault();
        setErr(""); setLoading(true);
        try {
            const { data } = await api.post("/auth/login", { email, password });
            login(data.token, data.user);
            nav(dest(data.user.role));
        } catch (e2) { setErr(formatApiError(e2.response?.data?.detail) || "Login failed"); }
        finally { setLoading(false); }
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-teal-950 via-teal-900 to-teal-800 grain grid place-items-center p-4">
            <div className="w-full max-w-md">
                <div className="text-center mb-6"><Logo /></div>
                <div className="card-teal rounded-2xl p-8">
                    <h1 className="font-serif text-2xl text-cream mb-1">Welcome back</h1>
                    <p className="text-cream-soft text-sm mb-6">Login to your Sudigi dashboard.</p>
                    <form onSubmit={submit} className="space-y-4">
                        <div className="space-y-1.5"><Label className="text-cream-soft text-sm">Email</Label><Input type="email" className="bg-teal-800/50 border-brandborder text-cream" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" required /></div>
                        <div className="space-y-1.5"><Label className="text-cream-soft text-sm">Password</Label><Input type="password" className="bg-teal-800/50 border-brandborder text-cream" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" required /></div>
                        {err && <p className="text-sm text-red-400" data-testid="login-error">{err}</p>}
                        <button type="submit" disabled={loading} className="btn-gold w-full rounded-full py-3 flex items-center justify-center gap-2" data-testid="login-submit">{loading && <Loader2 className="w-4 h-4 animate-spin" />} Login</button>
                    </form>
                    <p className="text-sm text-cream-soft mt-5 text-center">New customer? <Link to="/register" className="text-gold hover:underline">Create an account</Link></p>
                </div>
            </div>
        </div>
    );
}
